import { Heading } from '@src/components/atoms/heading';

import { Text, Wrapper } from './styles';

const GenericError = () => (
  <Wrapper>
    <Heading level="h5" centered>
      Oops, something went wrong!
    </Heading>

    <Text>We&apos;ll try to fix the issue as soon as possible. Please try again in a while.</Text>
  </Wrapper>
);

export default GenericError;
